import { render, staticRenderFns } from "./HeaderRelatorio.vue?vue&type=template&id=1398dafe&"
import script from "./HeaderRelatorio.vue?vue&type=script&lang=js&"
export * from "./HeaderRelatorio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports